import styled from "styled-components";


export const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 2rem;
`;

export const Button = styled.button<{show: boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    border: none;
    border-radius: 50%;
    background: #fff;
    color: #b4a7c5;
    font-size: 1rem;
    visibility: ${({show}) => show ? 'visible' : 'hidden'};
    
    &:hover {
        color: #57397e;
    }
`;